<template>
  <div class="sectionFirst contenido" id="how">
      
      <h1  class="headline" style="margin-top: 2rem;">En tres pasos certifica tu organización.</h1>
       
      <div class="md-layout">
          <div class="md-layout-item contenido sami-content" style="text-align: justify; margin: 2vw;">
                <div class="div-circle-white-container">
                    <span class="circle-white">
                         <img style="display: inline" src="@/assets/01.png" alt="samimetrics calcula tu huella">
                         <span class="inner-circle-white"> 1</span>
                    </span>
                    <h1 class="headline">Calcula</h1>
                </div>
              <span >
              </span>
              <p class="p-content">Al calcular los datos de consumo de tu empresa o producto puedes identificar las fuentes de emisión. Nosotros lo certificamos.</p>
              <p class="p-content">Con SAMI el software de la sustentabilidad, puedes calcular tu huella de carbono en minutos. </p>
              <div style="padding: 0 10vh 0 8vh">
                  <!-- <md-button class="md-raised md-btn-sami btn draw-border">SamiMetrics</md-button> -->
                  <a class="btn btn-white btn-animate" style="color: #707070;" href="http://www.samimetrics.com/" target="_blank" rel="sami sustantibilidad">
                  SAMIMETRICS
                  <md-tooltip md-direction="right">Samimetrics saber más</md-tooltip>  
                  </a>
              </div>
              
          </div>
          <div class="md-layout-item contenido" style="text-align: justify; margin: 2vw;">
              <span>
                  <div class="div-circle-white-container">
                    <span class="circle-white">
                         <img style="display:inline" src="@/assets/02.png" alt="sello sustentable reduce">
                         <span class="inner-circle-white"> 2</span>
                    </span>
                    <h1 class="headline">Reduce</h1>
                </div>

                
              </span>
              <p class="p-content last-content">Reduce las emisiones que has cuantificado. Te asesoramos con la planificación e implementación de medidas.</p>
              <span>
                <div class="div-circle-white-container">
                    <span class="circle-white">
                         <img style="display:inline" src="@/assets/03.png" alt="sello sustentable neutraliza tu huella">
                         <span class="inner-circle-white"> 3</span>
                    </span>
                    <h1 class="headline">Neutraliza</h1>
                </div>
              </span>
              <p class="p-content">Compensa la totalidad de tu huella de carbono o aquello que no has podido reducir. Te conectamos con créditos de carbono verificados. </p>
          </div>
      </div>
  </div>
</template>

<script>
var slideUp = {
    distance: '550%',
    origin: 'bottom',
    duration: 1550,
    opacity: 0.2,
    delay: 20
};

export default {
    name: 'first',
    data () {
        return {

        }
    },
    mounted () {
        let body = document.getElementById('how')
        for (let step = 0; step < 300; step++) {
            var div = document.createElement('div')
            div.className = 'white-point'
            var top = Math.ceil(Math.random() * 150)
            var left =  Math.ceil(Math.random() * 150)
            div.style.top = `${top.toString()}%`
            div.style.left = `${left.toString()}%`
            body.append(div)
        }

        //ScrollReveal().reveal('.headline', slideUp)
    }
}
</script>

<style>
.sectionFirst {
    width: 100vw;
    background: #00d371;
    padding: 4vw 8vw 4vw 8vw;
    color: #fafafa !important;
    position: relative;
}
.sectionFirst h1 {
    font-size: 2.5vw;
}
p {
    text-align: justify;
}

div.contenido {
    color: #fafafa !important;
}
.md-btn-sami {
    color: #707070 !important;
    width: 13vw !important;
    height: 2.8vw !important;
    border-radius: 25px !important;
    font-size: 10px; 
}
.p-content {
    padding: 0 5vw 0 5vw !important;
    font-size: 1.3vw;
    line-height: 1.5;
}

.div-circle-white-container {
  margin: 2rem 2rem 1rem 0rem;
  display: inline-flex;
}

.div-circle-white-container h1 {
    display: inline; 
    font-size: 3.8vw; 
    margin-left: 10px;
}

.circle-white {
  border-radius: 100%;
  width: 5vw;
  height: 5vw;
  box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  margin-bottom: -1rem;
  position: relative;
}

.inner-circle-white {
    background-color: #ffffff;
    border-radius: 100%;
    height: 2.5vw;
    width: 2.5vw;
    position:absolute;
    display: inline-block;
    box-shadow: 0 4px 7px 0 rgba(0, 0, 0, 0.16);
    top: -30%;
    left: 25%;
    color: #00d371;
    font-weight: bold;
    text-align: center;
    font-size: 1.5vw;
    padding: 15px;
}

.circle-white img {
  margin: auto;
  width: 100%;
}

.white-point {
    width: 7px;
    height: 4px;
    background-color: rgb(255, 255, 255, 0.2);
    border-radius: 100%;
    position: absolute;
    z-index: 0;
}


.btn {
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 35px;
  line-height: 1.5;
  font: 700 1rem 'open sans', sans-serif;
  letter-spacing: 0.05rem;
  width: 13vw;
  height: 3vw;
  border-radius: 30px;
  text-align: center;
  background-color: #707070;
  color: #ffffff;
  font-weight: bold;
  padding: 9px;
  font-size: 1vw
}
.btn:focus {
  outline: 2px dotted #01fdf2;
  border-radius: 55px;
}


.btn:link,
.btn:visited {
    text-transform: uppercase;
    text-decoration: none;
    display: inline-block;
    border-radius: 100px;
    transition: all .02s;
    position: absolute;
}

.btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.btn:active {
    transform: translateY(-1px);
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
}

.btn-white {
    background-color: #fff;
    color: #777;
}

.btn::after {
    content: "";
    display: inline-block;
    height: 100%;
    width: 100%;
    border-radius: 100px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    transition: all .4s;
}

.btn-white::after {
    background-color: #fff;
}

.btn:hover::after {
    transform: scaleX(1.4) scaleY(1.6);
    opacity: 0;
}

.btn-animated {
    animation: moveInBottom 5s ease-out;
    animation-fill-mode: backwards;
}

@keyframes moveInBottom {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }

    100% {
        opacity: 1;
        transform: translateY(0px);
    }
}
</style>